var map = {
	"./prom-2x1.png": 3934,
	"./prom-3sin.png": 7881,
	"./prom-3x2.png": 3322,
	"./prom-4x3.png": 4931,
	"./prom-6sin.png": 2168,
	"./prom-envio.png": 6585,
	"./prom2x1.png": 5614,
	"./prom3sin.png": 708,
	"./prom3x2.png": 9926,
	"./prom4x3.png": 4209,
	"./prom6sin.png": 2022,
	"./promenvio.png": 1100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4845;